import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const CustomSelect = ({
  values,
  defaultValue,
  onChange,
  placeholder,
  className,
  dropdownMatchSelectWidth = true,
  style = {},
}) => (
  <Select
    showSearch
    className={`${className} ant-select-border-bottom`}
    dropdownMatchSelectWidth={dropdownMatchSelectWidth}
    style={{
      width: '40%',
      ...style,
    }}
    placeholder={placeholder}
    onChange={onChange}
    value={defaultValue.name}
    filterOption={(inputValue, option) =>
      option.children.toString().toLowerCase().includes(inputValue.toLowerCase())
    }
    getPopupContainer={(triggerNode) => triggerNode}
    virtual={false}
  >
    {values.map((value) => (
      <Option key={value.id} value={value.id}>
        {value.name}
      </Option>
    ))}
  </Select>
);

export default CustomSelect;
